"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casale-corte-cerro": {
    "9418a3fa": [{
      "hkey": "c1b64c61",
      "slug": "arzo-ricciano",
      "name": "Arzo-Ricciano",
      "primary": true,
      "skipSearch": false
    }],
    "arzo": [{
      "hkey": "c1b64c61",
      "slug": "arzo-ricciano",
      "name": "Arzo-Ricciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "26ac2a9c": [{
      "hkey": "634ca70e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cafferonio": [{
      "hkey": "634ca70e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "casale-corte-cerro"
    }],
    "7943be4b": [{
      "hkey": "d0c2502d",
      "slug": "casale-corte-cerro",
      "name": "Casale Corte Cerro",
      "primary": true,
      "skipSearch": false
    }],
    "cassinone": [{
      "hkey": "d0c2502d",
      "slug": "casale-corte-cerro",
      "name": "Casale Corte Cerro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "60d37534": [{
      "hkey": "768bc8e4",
      "slug": "gabbio-cereda-ramate",
      "name": "Gabbio-Cereda-Ramate",
      "primary": true,
      "skipSearch": false
    }],
    "cereda": [{
      "hkey": "768bc8e4",
      "slug": "gabbio-cereda-ramate",
      "name": "Gabbio-Cereda-Ramate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "casale-corte-cerro"
    }],
    "12fc5e01": [{
      "hkey": "d0c2502d",
      "slug": "casale-corte-cerro",
      "name": "Casale Corte Cerro",
      "primary": true,
      "skipSearch": false
    }],
    "crebbia": [{
      "hkey": "d0c2502d",
      "slug": "casale-corte-cerro",
      "name": "Casale Corte Cerro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a9234b56": [{
      "hkey": "d0c2502d",
      "slug": "casale-corte-cerro",
      "name": "Casale Corte Cerro",
      "primary": true,
      "skipSearch": false
    }],
    "crottofantone": [{
      "hkey": "d0c2502d",
      "slug": "casale-corte-cerro",
      "name": "Casale Corte Cerro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c13bbba8": [{
      "hkey": "768bc8e4",
      "slug": "gabbio-cereda-ramate",
      "name": "Gabbio-Cereda-Ramate",
      "primary": true,
      "skipSearch": false
    }],
    "gabbio": [{
      "hkey": "768bc8e4",
      "slug": "gabbio-cereda-ramate",
      "name": "Gabbio-Cereda-Ramate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3ff21a72": [{
      "hkey": "d0c2502d",
      "slug": "casale-corte-cerro",
      "name": "Casale Corte Cerro",
      "primary": true,
      "skipSearch": false
    }],
    "motto": [{
      "hkey": "d0c2502d",
      "slug": "casale-corte-cerro",
      "name": "Casale Corte Cerro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8a394113": [{
      "hkey": "768bc8e4",
      "slug": "gabbio-cereda-ramate",
      "name": "Gabbio-Cereda-Ramate",
      "primary": true,
      "skipSearch": false
    }],
    "ramate": [{
      "hkey": "768bc8e4",
      "slug": "gabbio-cereda-ramate",
      "name": "Gabbio-Cereda-Ramate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "casale-corte-cerro"
    }],
    "c03ecaa7": [{
      "hkey": "c1b64c61",
      "slug": "arzo-ricciano",
      "name": "Arzo-Ricciano",
      "primary": true,
      "skipSearch": false
    }],
    "ricciano": [{
      "hkey": "c1b64c61",
      "slug": "arzo-ricciano",
      "name": "Arzo-Ricciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "casale-corte-cerro"
    }]
  }
};
exports["default"] = _default;